import { toast } from 'react-toastify';
import axios from '../../axios';

import {
   GET_ACCOUNT_WITH_DUP_GSTIN,
   GET_EMPTY_SERIALNO_ENTRY,
   GET_CGST_NOT_EQUAL_TO_SGST,
   GET_DUP_ITEM,
   GET_DUP_SERIALNO_IN_TRAN,
   GET_EXTRA_LEDGER,
   GET_ISSUE_DATE_LESS_THEN_PORR_DATE,
   GET_LD_WITH_OUT_CORRESPONDING_LI_OR_HEADER,
   GET_PR_DATE_LESS_THEN_P_DATE,
   GET_P_WITH_PARTY_DATE_PARTY_BILL_NO_DIFFERENCE,
   GET_PR_RATE_NOT_SAME_WITH_P_RATE,
   GET_S_DATE_LESS_THAN_P_DATE,
   GET_SR_DATE_LESS_THAN_S_DATE,
   GET_SAME_SERIAL_NO_WITH_DIFFERENET_ITEM,
   GET_SERIAL_NO_SOLD_WITHOUT_P,
   GET_SERIAL_NO_WITH_NEGATIVE_STOCK,
   GET_SERIAL_NO_WITH_STOCK,
   GET_TRAN_WITH_SERIAL_NO_WITHOUT_ID,
   GET_TRAN_WITH_MISSING_ACCOUNT,
   GET_TRAN_WITH_MISSING_ITEM,
   GET_TRAN_WITH_MISSING_TRANSPORT,
   GET_WITHOUT_LEDGER,
   GET_WRONG_SERIAL_NO_DUE_TO_LOSS_OF_INCONN,
   GET_OVER_ADJUSTMENT,
   GET_LI_ITEMID_NOT_EQUAL_LD_ITEMID,
   GET_BALANCE_DIFFERENCE_IN_LEDGER,
   GET_IN_COMPLETE_LEDGER_ENTRIES,
   GET_DUPLICATE_LEDGER_FOR_SAME_ACCOUNT,
   GET_AUTO_ENHANCE,
} from '../types';

export const getAccountWithDupGstIN = () => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/accountWithDuplicateGstIn');
      if (res.data.code === 1) {
         dispatch({
            type: GET_ACCOUNT_WITH_DUP_GSTIN,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getEmptySerialNo = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/emptySerialNoEntry', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_EMPTY_SERIALNO_ENTRY,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getCgstNotEqualToSgst = () => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/cgstNotEqualToSgstEntries');
      if (res.data.code === 1) {
         dispatch({
            type: GET_CGST_NOT_EQUAL_TO_SGST,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getDupItem = () => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/duplicateItem');
      if (res.data.code === 1) {
         dispatch({
            type: GET_DUP_ITEM,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getDupSerialNoINTran = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/duplicateSerialNoInSameTransaction', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_DUP_SERIALNO_IN_TRAN,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getExtraLedger = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/extraLedger', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_EXTRA_LEDGER,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getIssueDateLessThenPOrRDate = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/IssueDateLessThenPurchaseOrReceiveDate', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_ISSUE_DATE_LESS_THEN_PORR_DATE,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getLDWithOutCorresponingLIOrHeader = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/lineDetailWithOutLineItemOrHeader', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_LD_WITH_OUT_CORRESPONDING_LI_OR_HEADER,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getPRDateLessThenPDate = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/purchaseReturnDateLessThenPurchaseDate', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PR_DATE_LESS_THEN_P_DATE,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getPWithPartyDatePartyBillNoDifference = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/purchaseBillNoDifference', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_P_WITH_PARTY_DATE_PARTY_BILL_NO_DIFFERENCE,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getPRRateNotSameWithPRate = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/prRateNotSamePurchaseRate', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_PR_RATE_NOT_SAME_WITH_P_RATE,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSDateLessThanPDate = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/sDatelessThenpDate', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_S_DATE_LESS_THAN_P_DATE,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSRDateLessThanSDate = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/srDateLessThansDate', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SR_DATE_LESS_THAN_S_DATE,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSameSerialNoWithDifferenetItem = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/sameSerialNoWithDifferentItem', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SAME_SERIAL_NO_WITH_DIFFERENET_ITEM,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSerialNoSoldWithoutP = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/serialNosoleWithoutPurchase', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SERIAL_NO_SOLD_WITHOUT_P,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSerialNoWithNegativeStock = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/serialNoNegativeStock', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SERIAL_NO_WITH_NEGATIVE_STOCK,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSerialNoWithStock = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/serialNoWithStock', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SERIAL_NO_WITH_STOCK,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getTranWithSerialNoWithoutID = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/withoutSerialNoWithLD', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_TRAN_WITH_SERIAL_NO_WITHOUT_ID,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getTranWithMissingAccount = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/missingAccount', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_TRAN_WITH_MISSING_ACCOUNT,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getTranWithMissingItem = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/missingItem', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_TRAN_WITH_MISSING_ITEM,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getTranWithMissingTransport = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/missingTransport', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_TRAN_WITH_MISSING_TRANSPORT,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getWithoutLedger = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/withoutLedger', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_WITHOUT_LEDGER,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getWrongSerialNoDueToLossOfInConn = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/worngserialInterconnectivity', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_WRONG_SERIAL_NO_DUE_TO_LOSS_OF_INCONN,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getOverAdju = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/overAdjustment', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_OVER_ADJUSTMENT,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getLINotEqualLD = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/liItemIdNotEqualLdItemId', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_LI_ITEMID_NOT_EQUAL_LD_ITEMID,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getBalanceDifferenceInLedger = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/balanceDifferenceInLedger', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_BALANCE_DIFFERENCE_IN_LEDGER,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getIncompleteLedgerEntries = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/incompleteLedgerEntries', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_IN_COMPLETE_LEDGER_ENTRIES,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getDuplicateLedgerForSameAccount = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/osCheck/duplicateLedgerForSameAccount', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_DUPLICATE_LEDGER_FOR_SAME_ACCOUNT,
            payload: res.data.data,
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getAutoEnhance = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/item/autoEnhance', { params });
      console.log('Auto Enhance Response:', res.data);
      if (res.data.code === 1) {
         dispatch({
            type: GET_AUTO_ENHANCE,
            payload: res.data,
         });
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};
